import { render, staticRenderFns } from "./SWUpdate.vue?vue&type=template&id=d9683b58&scoped=true"
import script from "./SWUpdate.vue?vue&type=script&lang=js"
export * from "./SWUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9683b58",
  null
  
)

export default component.exports